var _defs, _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExitFullScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    zoomAndPan: "magnify",
    viewBox: "0 0 48 48",
    height: 64,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "c71e5f9495"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.488281 0 L 20 0 L 20 19 L 0.488281 19 Z M 0.488281 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "268224928b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 28 0 L 47.507812 0 L 47.507812 19 L 28 19 Z M 28 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "227617147a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 28 28 L 47.507812 28 L 47.507812 47.019531 L 28 47.019531 Z M 28 28 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a324dc80b4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.488281 28 L 20 28 L 20 47.019531 L 0.488281 47.019531 Z M 0.488281 28 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c71e5f9495)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 14.050781 -0.00390625 L 14.050781 13.558594 L 0.484375 13.558594 L 0.484375 18.984375 L 19.476562 18.984375 L 19.476562 -0.00390625 Z M 14.050781 -0.00390625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#268224928b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 47.507812 13.558594 L 33.941406 13.558594 L 33.941406 -0.00390625 L 28.519531 -0.00390625 L 28.519531 18.984375 L 47.507812 18.984375 Z M 47.507812 13.558594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#227617147a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 33.941406 47.015625 L 33.941406 33.453125 L 47.507812 33.453125 L 47.507812 28.027344 L 28.519531 28.027344 L 28.519531 47.015625 Z M 33.941406 47.015625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a324dc80b4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0.484375 33.453125 L 14.050781 33.453125 L 14.050781 47.015625 L 19.476562 47.015625 L 19.476562 28.027344 L 0.484375 28.027344 Z M 0.484375 33.453125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitFullScreen);
export default __webpack_public_path__ + "static/media/exitFullScreen.42017643784bc8b54c942af6cb1c9083.svg";
export { ForwardRef as ReactComponent };